import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import { useIntl } from 'react-intl';

import { userCan } from '../../helpers/Auth';

const CollectionSelectCollectionMessage = ({ enableAddNew }) => {
  const intl = useIntl();
  return (
    <Label for="selectCollection">
      {intl.formatMessage({ defaultMessage: 'Choose existing Collection' })}
      {(enableAddNew && userCan('collection.create')) && (
        <>
          {' '}{intl.formatMessage({ defaultMessage: 'or create a new one (+)' })}
        </>
      )}
    </Label>
  );
};

CollectionSelectCollectionMessage.propTypes = {
  enableAddNew: PropTypes.bool,
};

CollectionSelectCollectionMessage.defaultProps = {
  enableAddNew: true,
};

export default CollectionSelectCollectionMessage;
